<div class="signup-background">
  <img src="/assets/grafismo/1.svg" alt="Background" class="background-image" loading="lazy">
</div>

<div class="signup-modal">
  <div class="modal-content">
    <div class="signup-header">
      <div class="logo-container">
        <img src="../../../assets/logo/PNG/assinaturaVisual/amarelo.png" alt="AdvVenture Logo" class="signup-logo" loading="lazy">
      </div>
      <h1 class="signup-title">Criar conta</h1>
      <p class="signup-subtitle">Crie sua conta com e-mail e senha para começar a usar agora mesmo.</p>
    </div>

    <app-spinner-service></app-spinner-service>

    <form [formGroup]="form" class="form-grid pt-2 pl-6 pr-6 pb-6" (ngSubmit)="onSubmit()">
      <fieldset class="form-block">
        <legend class="form-block-legend">Dados da Empresa</legend>
        <div class="form-row">
          <div class="form-field form-field-6">
            <label for="nomeEmpresa">Nome da Empresa <span class="required">*</span></label>
            <input
              id="nomeEmpresa"
              type="text"
              pInputText
              formControlName="nomeEmpresa"
              placeholder="Digite o nome da empresa"
              [ngClass]="{'invalid-field': f['nomeEmpresa'].invalid && f['nomeEmpresa'].touched}" />
            <small *ngIf="f['nomeEmpresa'].invalid && f['nomeEmpresa'].touched" class="error-message">
              Nome da empresa é obrigatório.
            </small>
          </div>

          <div class="form-field form-field-6">
            <label for="nomeFantasia">Nome Fantasia <span class="required">*</span></label>
            <input
              id="nomeFantasia"
              type="text"
              pInputText
              formControlName="nomeFantasia"
              placeholder="Digite o nome fantasia"
              [ngClass]="{'invalid-field': f['nomeFantasia'].invalid && f['nomeFantasia'].touched}" />
            <small *ngIf="f['nomeFantasia'].invalid && f['nomeFantasia'].touched" class="error-message">
              Nome fantasia é obrigatório.
            </small>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field form-field-4">
            <label for="telefone">Telefone <span class="required">*</span></label>
            <input
              id="telefone"
              type="text"
              pInputText
              mask="(00) 00000-0000"
              formControlName="telefone"
              placeholder="(00) 00000-0000"
              [ngClass]="{'invalid-field': f['telefone'].invalid && f['telefone'].touched}" />
            <small *ngIf="f['telefone'].invalid && (f['telefone'].touched || submitted)" class="error-message">
              <span *ngIf="f['telefone'].errors?.['required']">Telefone é obrigatório.</span>
              <span *ngIf="f['telefone'].errors?.['telefoneInvalido']">Telefone deve ter 10 ou 11 dígitos (DDD + número).</span>
            </small>
          </div>

          <div class="form-field form-field-4">
            <label for="oab">OAB</label>
            <input
              id="oab"
              type="text"
              pInputText
              formControlName="oab"
              placeholder="Digite o número da OAB"
              [ngClass]="{'invalid-field': f['oab'].invalid && f['oab'].touched}" />
            <small *ngIf="f['oab'].invalid && f['oab'].touched" class="error-message">
              OAB deve ter no máximo 20 caracteres.
            </small>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-block mt-3">
        <legend class="form-block-legend">Acesso e Segurança</legend>
        <div class="form-row">
          <div class="form-field form-field-6">
            <label for="email">Email <span class="required">*</span></label>
            <input
              id="email"
              type="email"
              pInputText
              formControlName="email"
              placeholder="exemplo@empresa.com.br"
              [ngClass]="{'invalid-field': f['email'].invalid && f['email'].touched}" />
                         <small class="field-hint">Exemplo: contato&#64;empresa.com.br</small>
            <small *ngIf="f['email'].invalid && f['email'].touched" class="error-message">
              <span *ngIf="f['email'].errors?.['required']">Email é obrigatório.</span>
              <span *ngIf="f['email'].errors?.['email']">Email deve ser válido.</span>
            </small>
          </div>

          <div class="form-field form-field-6">
            <label for="senha">Senha <span class="required">*</span></label>
            <p-password
              [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}"
              formControlName="senha"
              [toggleMask]="true"
              [feedback]="true"
              placeholder="Digite sua senha"
              [ngClass]="{'invalid-field': f['senha'].invalid && f['senha'].touched}">
              <ng-template pTemplate="header">
                <h6>Escolha a senha</h6>
              </ng-template>
              <ng-template pTemplate="footer">
                <p-divider></p-divider>
                <p class="mt-2">Segurança da senha</p>
                <ul class="ps-4 ml-2 mt-0" style="line-height: 1.5; font-size: 10px;">
                  <li>Deve conter, ao menos, 8 caracteres</li>
                  <li>Deve conter, ao menos, uma letra minúscula</li>
                  <li>Deve conter, ao menos, uma letra maiúscula</li>
                  <li>Deve conter, ao menos, um número</li>
                  <li>Deve conter, ao menos, um caractere especial</li>
                </ul>
              </ng-template>
            </p-password>
                         <small class="field-hint">Exemplo: MinhaSenha&#64;123</small>
            <small *ngIf="f['senha'].invalid && f['senha'].touched" class="error-message">
              <span *ngIf="f['senha'].errors?.['required']">Senha é obrigatória.</span>
              <span *ngIf="f['senha'].errors?.['minlength']">Senha deve ter pelo menos 8 caracteres.</span>
              <span *ngIf="f['senha'].errors?.['pattern']">Senha deve conter uma combinação de letras maiúsculas, minúsculas, números e caracteres especiais.</span>
            </small>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field form-field-6">
            <label for="senhaConfirmacao">Confirmar Senha <span class="required">*</span></label>
            <p-password
              [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}"
              formControlName="senhaConfirmacao"
              [toggleMask]="true"
              [feedback]="false"
              placeholder="Confirme sua senha"
              [ngClass]="{'invalid-field': (f['senhaConfirmacao'].touched || f['senhaConfirmacao'].dirty) && (f['senhaConfirmacao'].invalid || form.hasError('passwordsDoNotMatch'))}">
            </p-password>
            <small class="field-hint">Digite a mesma senha novamente</small>
            <small *ngIf="(f['senhaConfirmacao'].touched || f['senhaConfirmacao'].dirty) && (f['senhaConfirmacao'].invalid || form.hasError('passwordsDoNotMatch'))" class="error-message">
              <span *ngIf="f['senhaConfirmacao'].errors?.['required']">Confirmação de senha é obrigatória.</span>
              <span *ngIf="form.hasError('passwordsDoNotMatch')">As senhas precisam corresponder.</span>
            </small>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-block mt-3">
        <legend class="form-block-legend">Documentação</legend>
        <div class="form-row">
          <div class="form-field form-field-3">
            <label for="tipoIdentificacaoCpfCnpj">Tipo de Documento <span class="required">*</span></label>
            <p-dropdown
              id="tipoIdentificacaoCpfCnpj"
              [options]="identificacoesCpfCnpjs"
              optionLabel="nome"
              optionValue="tipo"
              formControlName="tipoIdentificacaoCpfCnpj"
              (onChange)="onChangeidentificacaoCpfCnps($event.value)"
              placeholder="Selecione o tipo de documento"
              [ngClass]="{'invalid-field': f['tipoIdentificacaoCpfCnpj'].invalid && f['tipoIdentificacaoCpfCnpj'].touched}">
            </p-dropdown>
            <small *ngIf="f['tipoIdentificacaoCpfCnpj'].invalid && f['tipoIdentificacaoCpfCnpj'].touched" class="error-message">
              Tipo de documento é obrigatório.
            </small>
          </div>

          <div class="form-field form-field-3">
                         <label for="cpfCnpj">{{ tipoDocumentoLabel }} <span class="required" *ngIf="identificacaoCpfCnps !== '2'">*</span></label>
                         <input
               id="cpfCnpj"
               type="text"
               pInputText
               formControlName="cpfCnpj"
               [mask]="getMask()"
               (input)="onDocumentoInput($event, 'cpfCnpj')"
               [placeholder]="identificacaoCpfCnps === '2' ? 'Digite o documento do exterior' : 'Digite o ' + tipoDocumentoLabel.toLowerCase()"
               [ngClass]="{'invalid-field': f['cpfCnpj'].invalid && f['cpfCnpj'].touched}" />
                         <small class="field-hint" *ngIf="isCpfSelected">Exemplo: 123.456.789-00</small>
             <small class="field-hint" *ngIf="!isCpfSelected && identificacaoCpfCnps !== '2'">Exemplo: {{ exemploCnpj }}</small>
             <small class="field-hint" *ngIf="identificacaoCpfCnps === '2'">Exemplo: ABC123456789</small>
            <small *ngIf="f['cpfCnpj'].invalid && (f['cpfCnpj'].touched || submitted)" class="error-message">
              <span *ngIf="f['cpfCnpj'].errors?.['required']">{{ tipoDocumentoLabel }} é obrigatório.</span>
              <span *ngIf="f['cpfCnpj'].errors?.['cpfInvalido']">CPF inválido. Informe 11 dígitos.</span>
              <span *ngIf="f['cpfCnpj'].errors?.['cnpjInvalido']">CNPJ inválido. Informe 14 caracteres.</span>
              <span *ngIf="f['cpfCnpj'].errors?.['minlength']">Documento exterior muito curto.</span>
              <span *ngIf="f['cpfCnpj'].errors?.['maxlength']">Documento exterior deve ter no máximo 40 caracteres.</span>
            </small>
          </div>

          <div class="form-field form-field-3" *ngIf="isCpfSelected">
            <label for="cnpjEmpresa">CNPJ</label>
            <input
              id="cnpjEmpresa"
              type="text"
              pInputText
              formControlName="cnpjEmpresa"
              [mask]="mascaraCnpj"
              (input)="onDocumentoInput($event, 'cnpjEmpresa')"
              placeholder="Digite o CNPJ"
              [ngClass]="{'invalid-field': f['cnpjEmpresa'].invalid && f['cnpjEmpresa'].touched}" />
            <small class="field-hint">Exemplo: {{ exemploCnpj }}</small>
            <small *ngIf="f['cnpjEmpresa'].invalid && (f['cnpjEmpresa'].touched || submitted)" class="error-message">
              <span *ngIf="f['cnpjEmpresa'].errors?.['cnpjInvalido']">CNPJ inválido. Informe 14 caracteres.</span>
            </small>
          </div>

          <div class="form-field form-field-3">
            <label for="inscricaoMunicipal">Inscrição Municipal <span class="required">*</span></label>
            <input
              id="inscricaoMunicipal"
              type="text"
              pInputText
              formControlName="inscricaoMunicipal"
              placeholder="Digite a inscrição municipal"
              [ngClass]="{'invalid-field': f['inscricaoMunicipal'].invalid && f['inscricaoMunicipal'].touched}" />
            <small class="field-hint">Exemplo: 12345678</small>
            <small *ngIf="f['inscricaoMunicipal'].invalid && f['inscricaoMunicipal'].touched" class="error-message">
              <span *ngIf="f['inscricaoMunicipal'].errors?.['required']">Inscrição Municipal é obrigatória.</span>
              <span *ngIf="f['inscricaoMunicipal'].errors?.['maxlength']">Inscrição Municipal deve ter no máximo 20 caracteres.</span>
            </small>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field form-field-4">
            <label for="regimeTributario">Regime Tributário</label>
            <p-dropdown
              id="regimeTributario"
              [options]="regimesTributarios"
              formControlName="regimeTributario"
              placeholder="Selecione o regime tributário"
              [disabled]="true">
            </p-dropdown>
          </div>

          <div class="form-field form-field-4">
            <label for="RegimeApuracaoSimplesNacional">Regime de Apuração</label>
            <p-dropdown
              id="RegimeApuracaoSimplesNacional"
              formControlName="RegimeApuracaoSimplesNacional"
              [options]="regimeApuracaoOptions"
              placeholder="Selecione o Regime"
              optionLabel="label"
              optionValue="value"
              [ngClass]="{'invalid-field': f['RegimeApuracaoSimplesNacional'].invalid && (f['RegimeApuracaoSimplesNacional'].touched || submitted)}">
            </p-dropdown>
            <small *ngIf="f['RegimeApuracaoSimplesNacional'].invalid && (f['RegimeApuracaoSimplesNacional'].touched || submitted)" class="error-message">
              Regime de Apuração é obrigatório.
            </small>
          </div>

          <div class="form-field form-field-4">
            <label for="codigoTributarioMunicipio">Código Tributário do Município <span class="required">*</span></label>
            <input
              id="codigoTributarioMunicipio"
              type="text"
              pInputText
              formControlName="codigoTributarioMunicipio"
              placeholder="Digite o código tributário"
              [ngClass]="{'invalid-field': f['codigoTributarioMunicipio'].invalid && f['codigoTributarioMunicipio'].touched}" />
            <small class="field-hint">Exemplo: 171401 (Código tributário do município referente aos serviços oferecidos)</small>
            <small *ngIf="f['codigoTributarioMunicipio'].invalid && f['codigoTributarioMunicipio'].touched" class="error-message">
              Código Tributário do Município é obrigatório.
            </small>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-block mt-3">
        <legend class="form-block-legend">Endereço</legend>
        <div class="form-row">
          <div class="form-field form-field-6">
            <label for="logradouro">Rua <span class="required">*</span></label>
            <input
              id="logradouro"
              type="text"
              pInputText
              formControlName="logradouro"
              placeholder="Digite a rua"
              [ngClass]="{'invalid-field': f['logradouro'].invalid && f['logradouro'].touched}" />
            <small class="field-hint">Exemplo: Rua das Flores</small>
            <small *ngIf="f['logradouro'].invalid && f['logradouro'].touched" class="error-message">
              <span *ngIf="f['logradouro'].errors?.['required']">Rua é obrigatória.</span>
              <span *ngIf="f['logradouro'].errors?.['maxlength']">Rua deve ter no máximo 255 caracteres.</span>
            </small>
          </div>

          <div class="form-field form-field-2">
            <label for="numero">Número <span class="required">*</span></label>
            <input
              id="numero"
              type="text"
              pInputText
              formControlName="numero"
              placeholder="Nº"
              [ngClass]="{'invalid-field': f['numero'].invalid && f['numero'].touched}" />
            <small class="field-hint">Exemplo: 123</small>
            <small *ngIf="f['numero'].invalid && f['numero'].touched" class="error-message">
              <span *ngIf="f['numero'].errors?.['required']">Número é obrigatório.</span>
              <span *ngIf="f['numero'].errors?.['maxlength']">Número deve ter no máximo 10 caracteres.</span>
            </small>
          </div>

          <div class="form-field form-field-4">
            <label for="complemento">Complemento <span class="required">*</span></label>
            <input
              id="complemento"
              type="text"
              pInputText
              formControlName="complemento"
              placeholder="Digite o complemento"
              [ngClass]="{'invalid-field': f['complemento'].invalid && f['complemento'].touched}" />
            <small class="field-hint">Exemplo: Sala 101, Apto 202</small>
            <small *ngIf="f['complemento'].invalid && f['complemento'].touched" class="error-message">
              <span *ngIf="f['complemento'].errors?.['required']">Complemento é obrigatório.</span>
              <span *ngIf="f['complemento'].errors?.['maxlength']">Complemento deve ter no máximo 50 caracteres.</span>
            </small>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field form-field-4">
            <label for="bairro">Bairro <span class="required">*</span></label>
            <input
              id="bairro"
              type="text"
              pInputText
              formControlName="bairro"
              placeholder="Digite o bairro"
              [ngClass]="{'invalid-field': f['bairro'].invalid && f['bairro'].touched}" />
            <small class="field-hint">Exemplo: Centro</small>
            <small *ngIf="f['bairro'].invalid && f['bairro'].touched" class="error-message">
              <span *ngIf="f['bairro'].errors?.['required']">Bairro é obrigatório.</span>
              <span *ngIf="f['bairro'].errors?.['maxlength']">Bairro deve ter no máximo 255 caracteres.</span>
            </small>
          </div>

          <div class="form-field form-field-2">
            <label for="cep">CEP <span class="required">*</span></label>
            <input
              id="cep"
              type="text"
              pInputText
              formControlName="cep"
              mask="00000-000"
              placeholder="00000-000"
              [ngClass]="{'invalid-field': f['cep'].invalid && f['cep'].touched}" />
            <small class="field-hint">Exemplo: 12345-678</small>
            <small *ngIf="f['cep'].invalid && (f['cep'].touched || submitted)" class="error-message">
              <span *ngIf="f['cep'].errors?.['required']">CEP é obrigatório.</span>
              <span *ngIf="f['cep'].errors?.['cepInvalido']">CEP inválido. Informe 8 dígitos.</span>
            </small>
          </div>

          <div class="form-field form-field-2">
            <label for="pais">País</label>
            <p-dropdown
              [options]="paises"
              placeholder="Selecione o País"
              optionLabel="label"
              optionValue="value"
              formControlName="pais"
              id="pais"
              [disabled]="true">
            </p-dropdown>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field form-field-2">
            <label for="uf">Estado <span class="required">*</span></label>
            <p-dropdown
              id="uf"
              [options]="estados"
              optionLabel="label"
              optionValue="value"
              formControlName="uf"
              placeholder="Selecione o Estado"
              [ngClass]="{'invalid-field': f['uf'].invalid && f['uf'].touched}">
            </p-dropdown>
            <small *ngIf="f['uf'].invalid && f['uf'].touched" class="error-message">
              Estado é obrigatório.
            </small>
          </div>

          <div class="form-field form-field-4">
            <label for="municipio">Município <span class="required">*</span></label>
            <p-dropdown
              id="municipio"
              [options]="municipios"
              optionLabel="label"
              optionValue="value"
              formControlName="municipio"
              placeholder="Selecione o município"
              [ngClass]="{'invalid-field': f['municipio'].invalid && f['municipio'].touched}">
            </p-dropdown>
            <small *ngIf="f['municipio'].invalid && f['municipio'].touched" class="error-message">
              Município é obrigatório.
            </small>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-block mt-3">
        <legend class="form-block-legend">Certificado Digital</legend>
        <div class="form-row">
          <div class="form-field form-field-6 certificado-field">
            <label for="certificado">Certificado Digital <span class="required">*</span></label>
            <p-fileUpload
              #certificadoUpload
              name="file"
              chooseLabel="Escolher Certificado"
              [accept]="acceptCertificado"
              [maxFileSize]="maxCertificadoBytes"
              (onSelect)="onFileChange($event)"
              [auto]="true"
              customUpload
              [showUploadButton]="false"
              [showCancelButton]="false"
              [style]="{'width': '100%'}"
              class="custom-file-upload">
            </p-fileUpload>
            <div *ngIf="fileName" class="file-name">{{ fileName }}</div>
            <small class="field-hint">Apenas certificado digital A1 nos formatos .pfx ou .p12</small>
            <small *ngIf="certificadoInvalid && !certificadoFormatoInvalid" class="error-message">O certificado digital é obrigatório.</small>
            <small *ngIf="certificadoFormatoInvalid" class="error-message">Formato inválido. Use apenas arquivos .pfx ou .p12.</small>
          </div>

          <div class="form-field form-field-6">
            <label for="senhaCertificado">Senha do Certificado <span class="required">*</span></label>
            <p-password
              formControlName="senhaCertificado"
              [feedback]="false"
              [toggleMask]="true"
              placeholder="Digite a senha do certificado"
              [style]="{'width': '100%'}"
              [ngClass]="{'invalid-field': f['senhaCertificado'].invalid && f['senhaCertificado'].touched}">
              <ng-template pTemplate="icon">
                <i class="pi pi-lock"></i>
              </ng-template>
            </p-password>
            <small class="field-hint">Senha definida na emissão do certificado</small>
            <small *ngIf="f['senhaCertificado'].invalid && f['senhaCertificado'].touched" class="error-message">
              <span *ngIf="f['senhaCertificado'].errors?.['required']">Senha do certificado é obrigatória.</span>
            </small>
          </div>
        </div>
      </fieldset>

      <div class="form-actions mt-4">
        <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger" (click)="navigateToLogin()"></p-button>
        <p-button type="submit" label="Cadastrar" icon="pi pi-check"></p-button>
      </div>
    </form>
  </div>
</div>
